import { all } from 'redux-saga/effects';
import workflowSaga from './workflowSaga';
import plaidSaga from './plaidSaga';
import bankStatementsSaga from './bankStatementsSaga';

export default function* () {
  yield all([
    workflowSaga(),
    plaidSaga(),
    bankStatementsSaga(),
  ]);
}
